import { Capacitor } from "@capacitor/core";

// Share the user's invite link through whatever the platform offers:
// native share sheet (Capacitor Share) on iOS, navigator.share on
// capable web, clipboard as the universal fallback. Returns
// { shared: bool, copied: bool } so callers can toast appropriately.
// navigator.share is unreliable inside WKWebView — that's exactly why
// native goes through the plugin.

export function inviteUrlFor(inviteCode) {
  return `https://booda.app/invite/${inviteCode}`;
}

export async function shareInvite({ inviteCode, name }) {
  const url = inviteUrlFor(inviteCode);
  const text = `${name ? `${name} wants` : "Someone wants"} to cook with you on Booda — join their kitchen:`;

  if (Capacitor.isNativePlatform()) {
    try {
      const { Share } = await import("@capacitor/share");
      await Share.share({ title: "Join me on Booda", text, url });
      return { shared: true, copied: false };
    } catch (e) {
      // User cancelled the sheet — not an error worth surfacing.
      if (/cancel/i.test(String(e?.message || ""))) return { shared: false, copied: false };
      // Plugin missing/failed → clipboard fallback below.
    }
  } else if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title: "Join me on Booda", text, url });
      return { shared: true, copied: false };
    } catch (e) {
      if (e?.name === "AbortError") return { shared: false, copied: false };
      // Fall through to clipboard.
    }
  }

  const copied = await copyInviteLink(inviteCode);
  return { shared: false, copied };
}

export async function copyInviteLink(inviteCode) {
  const url = inviteUrlFor(inviteCode);
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
